<template>
  <div class="bg-white">
    <div class="container margin_80_55">
      <div class="main_title_2 text-center mb-2 mb-md-4">
        <span><em /></span>
        <h2 class="mb-1">
          {{ $t('lang.home.prices.title') }}

          <div class="btn-group m-1 p-1">
            <button
              type="button"
              class="btn btn-light dropdown-toggle prices-dropdown-btn"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                :src="currencyFlag(currency)"
                :alt="currency"
                class="flag_icon"
              >{{ $globalPrices[currency].symbol }}
            </button>
            <div class="dropdown-menu dropdown-menu-right prices-dropdown">
              <button
                v-for="(currency_data, id) in $globalPrices"
                :key="id"
                class="dropdown-item"
                type="button"
                @click="setPreferences('currency',id)"
              >
                <img
                  :src="currencyFlag(id)"
                  class="flag_icon"
                >
                <b class="pr-1">{{ currency_data.symbol }} </b>
                {{ $t('lang.navbar.currency_'+id) }}
              </button>
            </div>
          </div>
        </h2>
        <h3
          class="m-0"
          v-html="$t('lang.home.prices.subtitle')"
        />
      </div>

      <div class="row center prices-row p-2 centered-content">
        <!--  SERVICES BOX  -->
        <div class="col-12 col-lg-4 price-details-div p-4">
          <div class="box_faq">
            <i class="material-symbols-rounded">luggage</i>
            <h6>{{ $t('lang.home.prices.luggage') }}</h6>
            <p>{{ $t('lang.home.prices.luggage_text') }}</p>
          </div>

          <div class="box_faq">
            <i class="material-symbols-rounded">verified_user</i>
            <h6>{{ $t('lang.home.prices.insurance') }}</h6>
            <p v-html="$t('lang.home.prices.insurance_text')" />
            <p>
              <a
                href="/terms-and-conditions#insurance"
                target="_blank"
              > {{ $t('lang.home.prices.insurance_cond') }}</a>
            </p>
          </div>

          <div class="box_faq">
            <i class="material-symbols-rounded">loyalty</i>
            <h6>{{ $t('lang.home.prices.tag') }}</h6>
            <p>{{ $t('lang.home.prices.tag_text') }}</p>
          </div>

          <h6
            class="text-center mt-4"
            v-html="$t('lang.home.prices.price_details_title')"
          />
        </div>

        <div class="col">
          <div class="row">
            <!--  FIRST PRICE  -->
            <div class="col-12 col-md-6 first-price text-center centered-content">
              <div class="d-inline-block d-md-none price-img-div">
                <img
                  style="max-height: 150px; width: auto"
                  src="../../assets/img/illustrations/TravelersOneBag.png"
                  alt="Viajero con una maleta"
                  title="Viajero con una maleta"
                >
              </div>
              <div class="prices-div">
                <h2 class="color_text">
                  {{ $t('lang.home.prices.first_bag') }}
                </h2>
                <div class="price">
                  <span class="currency">{{ $globalPrices[currency].symbol }} </span>
                  <span class="price-value">
                    {{ Number($globalPrices[currency].first_bag).toLocaleString('de-DE') }}
                  </span>
                  <span class="price-duration"> {{ $t('lang.home.prices.unit') }}</span>
                </div>
                <img
                  class="price-img d-none d-md-flex"
                  height="500"
                  width="267"
                  src="../../assets/img/illustrations/TravelersOneBag.png"
                  alt="Viajero con una maleta"
                  title="Viajero con una maleta"
                >
              </div>
            </div>

            <hr class="d-block d-md-none prices-divisor">

            <!--  SECOND PRICE  -->
            <div class="col-12 col-md-6 text-center centered-content">
              <div class="d-inline-block d-md-none price-img-div">
                <img
                  style="width: 90%; max-width: 200px; height: auto"
                  src="../../assets/img/illustrations/TravelersTwoBags.png"
                  alt="Viajeros con dos maletas"
                  title="Viajeros con dos maletas"
                >
              </div>
              <div class="prices-div">
                <h2 class="color_text">
                  {{ $t('lang.home.prices.second_bag') }}
                </h2>
                <div class="price">
                  <span class="currency">{{ $globalPrices[currency].symbol }} </span>
                  <span class="price-value">
                    {{ Number($globalPrices[currency].add_bags).toLocaleString('de-DE') }}
                  </span>
                  <span class="price-duration">{{ $t('lang.home.prices.unit') }}</span>
                </div>
                <img
                  class="price-img d-none d-md-flex"
                  height="500"
                  width="494"
                  src="../../assets/img/illustrations/TravelersTwoBags.png"
                  alt="Viajeros con dos maletas"
                  title="Viajeros con dos maletas"
                >
              </div>
            </div>
          </div>

          <!--  LONG BOOKING DISCOUNT PAUSED  -->
          <!--          <p-->
          <!--            class="long-bookings-discount text-center"-->
          <!--            v-html="$t('lang.home.prices.discount')"-->
          <!--          />-->
        </div>
      </div>

      <p class=" w-100 m-0 font-italic text-center text-md-left">
        <small>
          * {{ $t('lang.home.prices.special_rate') }}
        </small>
      </p>
    </div>
  </div>
</template>

<script>
import getCountryFromIp from '@/components/CommonScripts/IPInfo';

export default {
  name: 'Prices',
  data() {
    return {
      currency: this.$store.state.main.currency ? this.$store.state.main.currency : 'USD',
    };
  },

  watch: {
    '$store.state.main.currency': function () {
      this.currency = this.$store.state.main.currency;
    },
  },

  async created() {
    // READ USER IP
    // only on user's first visit.
    // If there's already a currency selected doesn't check or override the selected.

    if (!this.$store.state.main.currency) {
      const country = await getCountryFromIp();

      if (this.$currencyByCountry[country.toUpperCase()]) {
        this.$store.dispatch('setCurrency', this.$currencyByCountry[country.toUpperCase()]);
      } else {
        this.$store.dispatch('setCurrency', 'USD');
      }
    }
  },
  methods: {
    setPreferences(type, value) {
      if (type === 'currency') {
        this.$store.dispatch('setCurrency', value);
        this.currency = value;
      }
    },
    currencyFlag(id) {
      return require(`../../assets/img/flags/currency/${id}.png`);
    },
  },
};
</script>

<style scoped>

</style>
